export default {
  SETTINGS: `Settings`,
  MORE_OPTIONS: `More`,
  VIDEO_PREVIEW: `Video Preview`,
  HELP: `Help`,
  VISIT_LINK_UNCLICKED: `Copy Visit Link`,
  VISIT_LINK_CLICKED: `Link Copied!`,
  REPORT_ISSUE: `Report Issue`,
  FLIP: `Flip`,
  SELECTED: `selected`,
  GRID_VIEW: `Grid View`,
  SINGLE_VIEW: `Single View`,
  LEAVE: 'Leave',
  MUTE: 'Mute',
  UNMUTE: 'Unmute',
  START_VIDEO: 'Start Video',
  STOP_VIDEO: 'Stop Video',
  FLIP_TO_FRONT: `Flip to Front`,
  FLIP_TO_BACK_BUTTON: `Flip to Back`,
  DEVICE_SETTINGS: `Device Settings`,
  CHAT: `Chat`,
  OPEN_CHAT_BUTTON: `Chat Open`,
  NEW_CHAT_BUTTON: `New Chat`,
  RECONNECT: 'Reconnect',

  CALL_SCREEN_LEAVE_CONFIRMATION_HEADER: `Leave the Call`,
  CALL_SCREEN_LEAVE_CONFIRMATION_CONTENT: `Are you sure you want to exit your telehealth visit?`,
  CALL_SCREEN_LEAVE_CALL_BUTTON: `Leave Call`,
  CALL_SCREEN_LEAVE_STAY_ON_CALL_BUTTON: `Stay on Call`,
};
